import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=1ed59424&scoped=true"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateAccount.vue?vue&type=style&index=0&id=1ed59424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed59424",
  null
  
)

export default component.exports